import { render, staticRenderFns } from "./NewSection.vue?vue&type=template&id=8aa231a6&scoped=true&"
import script from "./NewSection.vue?vue&type=script&lang=js&"
export * from "./NewSection.vue?vue&type=script&lang=js&"
import style0 from "./NewSection.vue?vue&type=style&index=0&id=8aa231a6&lang=scss&scoped=true&"
import style1 from "./NewSection.vue?vue&type=style&index=1&id=8aa231a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa231a6",
  null
  
)

export default component.exports